/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AutopayBatchDetails } from '../models/AutopayBatchDetails';
import type { AutopayBatchUpdate } from '../models/AutopayBatchUpdate';
import type { AutoPaymentBatchExport } from '../models/AutoPaymentBatchExport';
import type { AutoPaymentDetails } from '../models/AutoPaymentDetails';
import type { AutoPaymentExport } from '../models/AutoPaymentExport';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class AutoPaysVService {

    /**
     * @param districtId
     * @returns AutoPaymentDetails Created
     * @throws ApiError
     */
    public static async autoPaysVCreateBatch(
        districtId: string,
    ): Promise<AutoPaymentDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/batch`,
            query: {
                'districtId': districtId,
            },
        });
        return result.body;
    }

    /**
     * @param autopayId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async autoPaysVGetBatch(
        autopayId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/batch/${autopayId}/get`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param autopayId
     * @returns AutoPaymentBatchExport OK
     * @throws ApiError
     */
    public static async autoPaysVGetExportForId(
        autopayId: string,
    ): Promise<Array<AutoPaymentBatchExport>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/autopay/batch/${autopayId}/export`,
        });
        return result.body;
    }

    /**
     * @param autopayId
     * @param requestBody
     * @returns AutopayBatchDetails OK
     * @throws ApiError
     */
    public static async autoPaysVUpdateBatch(
        autopayId: string,
        requestBody?: Array<AutopayBatchUpdate>,
    ): Promise<Array<AutopayBatchDetails>> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/autopay/batch/${autopayId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param autopayId
     * @returns any No Content
     * @throws ApiError
     */
    public static async autoPaysVCancelBatch(
        autopayId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/autopay/batch/${autopayId}/cancel`,
        });
        return result.body;
    }

    /**
     * @param autopayId
     * @returns any Accepted
     * @throws ApiError
     */
    public static async autoPaysVPostAutoPay(
        autopayId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/batch/${autopayId}/run`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async autoPaysVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AutoPaymentDetails OK
     * @throws ApiError
     */
    public static async autoPaysVGetExport(
        requestBody?: PagingQuery,
    ): Promise<AutoPaymentDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param autoPayId
     * @returns AutoPaymentDetails OK
     * @throws ApiError
     */
    public static async autoPaysVGetById(
        autoPayId: string,
    ): Promise<AutoPaymentDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/autopay/${autoPayId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param autopayId
     * @returns AutoPaymentExport OK
     * @throws ApiError
     */
    public static async autoPaysVGetExportForId1(
        autopayId: string,
    ): Promise<AutoPaymentExport> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/autopay/${autopayId}/export`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param autoPayId
     * @returns any Accepted
     * @throws ApiError
     */
    public static async autoPaysVRerunFailedPayments(
        autoPayId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/batch/${autoPayId}/rerun`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async autoPaysVGetPaymentResults(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/results/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AutoPaymentBatchExport OK
     * @throws ApiError
     */
    public static async autoPaysVGetPaymentResultsExport(
        requestBody?: PagingQuery,
    ): Promise<Array<AutoPaymentBatchExport>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/autopay/results/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}